export default class DateUtils {
	static handleDateFormatRetroCompatibility(format) {
		return format.replace('DD', 'd').replace('MM', 'm').replace('YYYY', 'Y').replace('HH', 'H').replace('mm', 'i');
	}

	static getFlatPickr(el, forceDateFormat = null) {
		if (forceDateFormat) {
			if (!el.getAttribute('data-format-original')) {
				el.setAttribute('data-format-original', el.getAttribute('data-format'));
			}
			el.setAttribute('data-format', forceDateFormat);
		}
		const dateformat = DateUtils.handleDateFormatRetroCompatibility(el.getAttribute('data-format'));
		const mode = el.getAttribute('data-mode') ?? 'single';
		const minDateAttr = el.getAttribute('data-min-date');
		const hasTime = /\d{2}:\d{2}/.test(minDateAttr);

		const options = {
			dateFormat: dateformat,
			allowInput: true,
			enableTime: dateformat.toLowerCase().includes('h'),
			mode,
			showMonths: mode === 'single' ? 1 : 2,
		};
		if (hasTime) {
			const minDateTime = new Date(minDateAttr);
			options.minTime = `${minDateTime.getHours()}:${minDateTime.getMinutes()}`;
			options.onChange = function (selectedDates, dateStr, instance) {
				const selectedDate = new Date(selectedDates[0]);

				if (selectedDate.toDateString() === minDateTime.toDateString()) {
					instance.set('minTime', `${minDateTime.getHours()}:${minDateTime.getMinutes()}`);
				} else {
					instance.set('minTime', null);
				}
			};
		}
		return flatpickr(el, options);
	}

	static timeSync(el, addSeconds = 0) {
		const dateformat = el.getAttribute('data-format');
		const newValue = moment(new Date()).add(addSeconds, 'second').format(dateformat);
		DateUtils.getFlatPickr(el).setDate(newValue, true);
	}

	/**
	 * Sostituisce l'icona orologio con un orologio funzionante
	 * @param {HTMLElement} element - Elemento da sostituire
	 * @param {Date|string} time - Ora da mostrare (Date object o stringa)
	 * @param {number} size - Dimensione dell'orologio
	 */
	static replaceClockIcon(element, time = new Date(), size = 16) {
		/**
		 * Converte un'ora in gradi per le lancette
		 * @param {number} hours - Ore (0-23)
		 * @param {number} minutes - Minuti (0-59)
		 * @returns {object} Gradi per ore, minuti e secondi
		 */
		function timeToDegrees(hours, minutes) {
			// Calcola i gradi per ogni lancetta
			const hourDegrees = (hours % 12) * 30 + (minutes / 60) * 30; // 30° per ora + movimento graduale
			const minuteDegrees = minutes * 6; // 6° per minuto

			return {
				hours: hourDegrees,
				minutes: minuteDegrees,
			};
		}

		/**
		 * Crea l'SVG dell'orologio
		 * @param {number} size - Dimensione dell'orologio in pixel
		 * @param {object} degrees - Gradi delle lancette
		 * @returns {string} SVG dell'orologio
		 */
		function createClockSVG(size = 16, degrees = { hours: 0, minutes: 0 }) {
			const center = size / 2;
			const radius = size * 0.4;

			// Calcola le posizioni delle lancette
			const hourLength = radius * 0.5;
			const minuteLength = radius * 0.7;

			// Converti gradi in radianti
			const hourRad = ((degrees.hours - 90) * Math.PI) / 180;
			const minuteRad = ((degrees.minutes - 90) * Math.PI) / 180;

			// Calcola le coordinate delle lancette
			const hourX = center + hourLength * Math.cos(hourRad);
			const hourY = center + hourLength * Math.sin(hourRad);
			const minuteX = center + minuteLength * Math.cos(minuteRad);
			const minuteY = center + minuteLength * Math.sin(minuteRad);

			return `
            <svg width="${size}" height="${size}" viewBox="0 0 ${size} ${size}" style="display: inline-block; vertical-align: middle; margin-top: -2px; margin-right: -1px;">
                <!-- Cerchio esterno -->
                <circle cx="${center}" cy="${center}" r="${radius}" fill="#fff" stroke="#fff" stroke-width="1" />
                
                <!-- Lancetta delle ore -->
                <line x1="${center}" y1="${center}" x2="${hourX}" y2="${hourY}" stroke="var(--primary)" stroke-width="1.2" />
                
                <!-- Lancetta dei minuti -->
                <line x1="${center}" y1="${center}" x2="${minuteX}" y2="${minuteY}" stroke="var(--primary)" stroke-width="1.2" />
            </svg>
        `;
		}

		let targetTime;

		// Parsing dell'ora
		if (typeof time === 'string') {
			if (time === '') {
				element.innerHTML = '';
				if (!element.classList.contains('fa-clock')) {
					element.classList.add('fa-clock');
				}
				if (!element.classList.contains('fa-solid')) {
					element.classList.add('fa-solid');
				}
				return;
			}
			// non importa il giorno, ne metto uno a caso
			const match = time.match(/[0-9]{2}:[0-9]{2}/);
			time = '2025-01-01 ' + (match ? match[0] : '00:00');
			targetTime = new Date(time);
		} else if (time instanceof Date) {
			targetTime = time;
		} else {
			targetTime = new Date();
		}

		// Estrai ore, minuti e secondi
		const hours = targetTime.getHours();
		const minutes = targetTime.getMinutes();

		// Calcola i gradi
		const degrees = timeToDegrees(hours, minutes);

		// Crea l'SVG
		const clockSVG = createClockSVG(size, degrees);

		if (element.classList.contains('fa-clock')) {
			element.classList.remove('fa-clock');
		}
		if (element.classList.contains('fa-solid')) {
			element.classList.remove('fa-solid');
		}

		// Sostituisci il contenuto
		element.innerHTML = clockSVG;

		// Aggiungi classe per stili CSS
		element.classList.add('easter-egg-clock');
	}
}
